import React, { useState } from "react";
import Calendar from "./Calendar";
import CalendarContext from "./CalendarContext";

export default function CalendarIndex() {
    const [filters, setFilters] = useState({ module: "all" });

    return (
        <CalendarContext.Provider value={{ filters, setFilters }}>
            <Calendar />
        </CalendarContext.Provider>
    );
}
